





























































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import Requester from '../../requester';

import { Consulta } from '../../../../back/src/entity/Consulta';
import { PressaoArterial } from '../../../../back/src/entity/PressaoArterial';
import { ConsultaPutFormData, PressaoArterialForm } from '../../../../back/src/types';

import ThePressoesArteriaisDadosDialog from '../pressoes_arteriais/ThePressoesArteriaisDadosDialog.vue';
import PressaoArterialAlert from '../pressoes_arteriais/PressaoArterialAlert.vue';

export default Vue.extend({
  name: 'ConsultaForm',
  props: {
    consulta: Object as () => Consulta,
    isColetiva: {
      default: false,
    },
  },
  components: {
    ThePressoesArteriaisDadosDialog,
    PressaoArterialAlert,
  },
  data() {
    return {
      dialogPressaoArterialDados: false,
      loading: false,
      pressaoArterialSelecionada: null,
      pressoes_arteriais: [] as PressaoArterialForm[],
      form: {
        pesoKilos: '',
        freq_card_materna: '',
        pressao_min: '',
        pressao_max: '',
        observacoes: '',
        remover: false,
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
    };
  },
  computed: {
    pacienteNome() {
      return this.consulta.paciente.nome as string;
    },
    pesoGramas(): number | null {
      if (!this.form.pesoKilos) {
        return null;
      }
      const pesoKilos = Number(this.form.pesoKilos.replace(',', '.'));
      if (pesoKilos > 0) {
        return Math.round(pesoKilos * 1000);
      }
      return null;
    },
    rulesPressaoMin() {
      return [
        () => {
          if ((!this.form.pressao_max || this.form.pressao_max.length === 0)
            && (!this.form.observacoes || this.form.observacoes.length === 0)) {
            return true;
          }
          return (this.form.pressao_min.length > 0) || 'Campo obrigatório';
        },
      ];
    },
    rulesPressaoMax() {
      return [
        () => {
          if ((!this.form.pressao_min || this.form.pressao_min.length === 0)
            && (!this.form.observacoes || this.form.observacoes.length === 0)) {
            return true;
          }
          return (this.form.pressao_max.length > 0) || 'Campo obrigatório';
        },
      ];
    },
    formConsulta(): Vue & {
      validate: () => boolean,
      resetValidation: () => boolean,
      reset: () => boolean
      } {
      return this.$refs.formConsulta as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean,
        reset: () => boolean,
      };
    },
  },
  mounted() {
    this.preencheInputs();
  },
  methods: {
    // eslint-disable-next-line func-names
    submitFormDebounce: _.debounce(async function () { await this.submitForm(); }, 200),
    async submitForm() {
      this.loading = true;
      if (!this.formConsulta.validate()) {
        this.loading = false;
        return;
      }
      const formData: ConsultaPutFormData = {
        id: this.consulta.id,
        peso_gramas: this.pesoGramas,
        freq_card_materna: this.form.freq_card_materna,
        pressoes_arteriais: this.pressoes_arteriais,
      };
      // se tiver medida de pressao
      if (!!this.form.pressao_min && !!this.form.pressao_max) {
        const novaPressao: PressaoArterialForm = {
          id: null,
          observacoes: this.form.observacoes || null,
          min: this.form.pressao_min,
          max: this.form.pressao_max,
          remover: this.remover,
          created: new Date(),
        };
        if (formData.pressoes_arteriais !== undefined) {
          formData.pressoes_arteriais.push(novaPressao);
        }
      }
      try {
        const response = await Requester.consulta.alteraConsulta(formData);
        if (response.errors.length > 0) {
          this.$root.$emit('avisoSnackbar', { color: 'error', text: response.errors });
        } else {
          this.$emit('close-dialog');
          this.$root.$emit('avisoSnackbar', { color: 'success', text: 'Dados salvos com sucesso!' });
          this.$emit('atualiza-consulta', this.consulta.id);
          this.formConsulta.reset();
        }
      } catch (err) {
        this.$root.$emit('requestError', err);
      } finally {
        this.loading = false;
        this.formConsulta.resetValidation();
      }
    },
    preencheInputs() {
      if (this.consulta.peso_gramas) {
        const pesoKg = this.consulta.peso_gramas / 1000;
        this.form.pesoKilos = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(pesoKg);
      } else {
        this.form.pesoKilos = '';
      }
      this.form.freq_card_materna = this.consulta.freq_card_materna;
      this.pressoes_arteriais = _.map(this.consulta.pressoes_arteriais, pressao => ({
        id: pressao.id,
        max: pressao.max,
        min: pressao.min,
        observacoes: pressao.observacoes,
        remover: false,
        created: pressao.created,
        nome_criador: pressao.usuario_created_by.nome || '',
      } as PressaoArterialForm));
    },
    colorPressaoArterial(pressaoArterialForm: PressaoArterialForm) {
      if (pressaoArterialForm.remover) {
        return 'error';
      }
      if (pressaoArterialForm.id) {
        return 'primary';
      }
      return 'success';
    },
    colorInfoPressaoArterial(pressaoArterialForm: PressaoArterialForm) {
      if (pressaoArterialForm.remover) {
        return 'error';
      }
      if (pressaoArterialForm.observacoes) {
        return 'primary';
      }
      return 'grey';
    },
    abreDialogPressaoArterial(pressaoArterial: PressaoArterial) {
      this.pressaoArterialSelecionada = pressaoArterial;
      this.dialogPressaoArterialDados = true;
    },
    removerPressaoArterial(pressaoArterial: PressaoArterialForm) {
      if (pressaoArterial.id) {
        const index = _.findIndex(
          this.pressoes_arteriais as PressaoArterialForm[],
          el => (el.id === pressaoArterial.id),
        );
        if (index >= 0) {
          this.$set(this.pressoes_arteriais[index], 'remover', true);
        }
      } else {
        _.pull(this.pressoes_arteriais, pressaoArterial);
      }
      this.dialogPressaoArterialDados = false;
    },
    desfazerRemocaoPressaoArterial(pressaoArterial: PressaoArterialForm) {
      if (pressaoArterial.id) {
        const index = _.findIndex(
          this.pressoes_arteriais as PressaoArterialForm[],
          el => (el.id === pressaoArterial.id),
        );
        if (index >= 0) {
          this.$set(this.pressoes_arteriais[index], 'remover', false);
        }
      }
      this.dialogPressaoArterialDados = false;
    },
  },
  watch: {
    consulta() {
      this.preencheInputs();
    },
  },
});
